export default class BreakpointCalculator {
  constructor (breakpoints) {
    this._breakpoints = breakpoints
    this._breakpointKeys = Object.keys(this._breakpoints)
  }

  getBreakpointByWidth (width) {
    for (let index = this._breakpointKeys.length - 1; index >= 0; index--) {
      const breakpoint = this._breakpointKeys[index]
      if (width >= this.getBreakpointLowerBound(breakpoint)) {
        return breakpoint
      }
    }
    return null
  }

  isBreakpoint (breakpointA, breakpointB) {
    return breakpointA === breakpointB
  }

  isBreakpointAny (breakpoint, breakpoints) {
    return breakpoints.includes(breakpoint)
  }

  isBreakpointUp (breakpoint, fromBreakpoint) {
    const breakpointIndex = this._breakpointKeys.indexOf(breakpoint)
    const fromBreakpointIndex = this._breakpointKeys.indexOf(fromBreakpoint)
    return breakpointIndex >= fromBreakpointIndex
  }

  isBreakpointDown (breakpoint, toBreakpoint) {
    const breakpointIndex = this._breakpointKeys.indexOf(breakpoint)
    const toBreakpointIndex = this._breakpointKeys.indexOf(toBreakpoint)
    return breakpointIndex <= toBreakpointIndex
  }

  isBreakpointBetween (breakpoint, fromBreakpoint, toBreakpoint) {
    const breakpointIndex = this._breakpointKeys.indexOf(breakpoint)
    const fromBreakpointIndex = this._breakpointKeys.indexOf(fromBreakpoint)
    const toBreakpointIndex = this._breakpointKeys.indexOf(toBreakpoint)
    return (
      breakpointIndex >= fromBreakpointIndex &&
      breakpointIndex <= toBreakpointIndex
    )
  }

  getPreviousBreakpoint (breakpoint) {
    return this.getRelativeBreakpoint(breakpoint, -1)
  }

  getNextBreakpoint (breakpoint) {
    return this.getRelativeBreakpoint(breakpoint, +1)
  }

  getRelativeBreakpoint (breakpoint, relativePosition) {
    const breakpointIndex = this._breakpointKeys.indexOf(breakpoint)
    const resultIndex = breakpointIndex + relativePosition
    const resultBreakpoint = this._breakpointKeys[resultIndex]
    if (resultBreakpoint !== undefined) {
      return resultBreakpoint
    } else {
      return null
    }
  }

  getBreakpointLowerBound (breakpoint) {
    return this._breakpoints[breakpoint]
  }

  getBreakpointUpperBound (breakpoint) {
    const nextBreakpoint = this.getNextBreakpoint(breakpoint)
    if (nextBreakpoint !== null) {
      return this._breakpoints[nextBreakpoint]
    }
    return Number.POSITIVE_INFINITY
  }
}
